<div class="mx-auto p-6">
  <div class="mb-2">
    <p id="gestion-des-etiquettes" class="titre1 mt-4">{{ (isCreationMode ?
      'LEARNING_PATH_MANAGEMENT.CREATE_LEARNING_PATH' :
      'LEARNING_PATH_MANAGEMENT.EDIT_LEARNING_PATH') | translate }}
      <mat-icon
      class="material-symbols-outlined text-[38px] w-[45px] h-[45px] mt-[5px] mr-[30px] float-right">conversion_path</mat-icon>
    </p>
  </div>
  @if (isLoading) {
    <div class="flex justify-center items-center h-64">
      <mat-spinner color="accent"></mat-spinner>
    </div>
  }

  @if (!isLoading) {
    <div class="space-y-8">
      <div class="relative mt-12">
        <h2 class="titre2">{{ 'LEARNING_PATH_MANAGEMENT.TITRE_CONTENU' | translate }}</h2>
        @if (!hasTitle()) {
          <div class="mb-4 text-rougeNovo">
            {{ 'LEARNING_PATH_MANAGEMENT.TITLE_REQUIRED' | translate }}
          </div>
        }
        <div class="grid grid-cols-1 md:grid-cols-3 gap-6">
          @for (lang of supportedLanguages; track lang) {
            <div>
              <label class="block text-sm font-medium">{{ lang.label | translate }}</label>
              <input title="langue" [attr.title]="lang.code" [(ngModel)]="locales[lang.code]"
                class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-red-500 focus:ring-red-500">
              </div>
            }
          </div>
          <div class="mt-8">
            <h2 class="titre2">{{ 'LEARNING_PATH_MANAGEMENT.RECURRENCE' | translate }}</h2>
            <div class="mt-2">
              <label class="flex items-center gap-2">
                <input type="checkbox" [(ngModel)]="estRecurrent" (ngModelChange)="onEstRecurrentChange()"
                  class="rounded border-gray-300 text-red-600 focus:ring-red-500">
                <span class="text-sm font-medium">{{ 'LEARNING_PATH_MANAGEMENT.IS_RECURRENT' | translate }}</span>
              </label>
            </div>
            @if (estRecurrent) {
              <div class="mt-3 max-w-xs">
                <label class="block text-sm font-medium">{{ 'LEARNING_PATH_MANAGEMENT.RECURRENCE_INTERVAL' | translate }}</label>
                <select title="recurrence" [(ngModel)]="recurrenceEnAnnees"
                  class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-red-500 focus:ring-red-500">
                  @for (annee of recurrenceOptions; track annee) {
                    <option [ngValue]="annee">{{ 'LEARNING_PATH_MANAGEMENT.RECURRENCE_YEARS' | translate: { count: annee } }}</option>
                  }
                </select>
                @if (!hasRecurrenceInterval()) {
                  <div class="mt-2 text-rougeNovo">
                    {{ 'LEARNING_PATH_MANAGEMENT.RECURRENCE_REQUIRED' | translate }}
                  </div>
                }
              </div>
            }
          </div>
          <div class="flex justify-between items-center mt-8">
            <h2 class="titre2">{{ 'LEARNING_PATH_MANAGEMENT.CONTENT_MANAGEMENT' | translate }}</h2>
            <button (click)="exporterListeContenusCompletes()" class="btn-primary-novo flex items-center gap-2">
              {{ 'LEARNING_PATH_MANAGEMENT.EXPORT_COMPLETED_CONTENT_LIST' | translate }}
            </button>
          </div>
          @if (!hasPackages()) {
            <div class="mb-4 text-rougeNovo">
              {{ 'LEARNING_PATH_MANAGEMENT.PACKAGES_REQUIRED' | translate }}
            </div>
          }
          <div class="grid grid-cols-2 gap-6">
            <div cdkDropList #availableList="cdkDropList" [cdkDropListData]="availablePackages"
              [cdkDropListConnectedTo]="[parcoursFormationList]"
              class="p-6 rounded-lg border border-gray-300 min-h-[400px] flex flex-col"
              (cdkDropListDropped)="onDrop($event)">
              <div class="flex justify-between items-center mb-4">
                <h3 class="text-xl font-semibold">{{ 'LEARNING_PATH_MANAGEMENT.AVAILABLE_PACKAGES' | translate
                }}</h3>
                <div class="px-3 py-1 invisible"></div>
              </div>
              <div class="mb-4">
                <input type="text" [(ngModel)]="searchAvailable" (ngModelChange)="filterAvailablePackages()"
                  placeholder="{{ 'LEARNING_PATH_MANAGEMENT.SEARCH_IN_AVAILABLE' | translate }}"
                  class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-red-500">
                </div>
                <div class="flex-1 space-y-4 overflow-y-auto max-h-[280px]">
                  @for (package of availablePackages; track package) {
                    <div cdkDrag>
                      <app-package-card [package]="package"></app-package-card>
                    </div>
                  }
                </div>
              </div>
              <div cdkDropList #parcoursFormationList="cdkDropList" [cdkDropListData]="packagesInParcoursFormation"
                [cdkDropListConnectedTo]="[availableList]"
                class="p-6 rounded-lg border border-gray-300 min-h-[400px] flex flex-col"
                (cdkDropListDropped)="onDrop($event)">
                <div class="flex justify-between items-center mb-4">
                  <h3 class="text-xl font-semibold">{{ 'LEARNING_PATH_MANAGEMENT.PACKAGES_IN_TRAINING_PATH' |
                  translate }}</h3>
                  <button (click)="clearPackages()"
                    class="px-3 py-1 bg-red-500 text-white rounded-lg hover:bg-red-600 flex items-center gap-2">
                    <mat-icon>clear_all</mat-icon>
                    {{ 'LEARNING_PATH_MANAGEMENT.CLEAR' | translate }}
                  </button>
                </div>
                <div class="mb-4">
                  <input type="text" [(ngModel)]="searchInPath" (ngModelChange)="filterPackagesInPath()"
                    placeholder="{{ 'LEARNING_PATH_MANAGEMENT.SEARCH' | translate }}"
                    class="w-full px-4 py-2 rounded-lg focus:outline-none focus:ring-2 focus:ring-red-500">
                  </div>
                  <div class="flex-1 space-y-4 overflow-y-auto max-h-[280px]">
                    @for (item of packagesInParcoursFormation; track item) {
                      <div cdkDrag class="flex items-center gap-4">
                        <div class="flex-shrink-0 w-8 text-center font-semibold">
                          {{ item.ordreAffichage }}
                        </div>
                        <div class="flex-grow">
                          <app-package-card [package]="item.package"></app-package-card>
                        </div>
                      </div>
                    }
                  </div>
                </div>
              </div>
            </div>
            <div class="relative">
              <h2 class="titre2">{{ 'LEARNING_PATH_MANAGEMENT.ASSIGNMENTS' | translate }}</h2>
              @if (!hasAssignment()) {
                <div class="mb-4 text-rougeNovo">
                  {{ 'LEARNING_PATH_MANAGEMENT.ASSIGNMENT_REQUIRED' | translate }}
                </div>
              }
              <div class="grid grid-cols-2 gap-6">
                <div class="p-6 rounded-md border border-gray-300">
                  <h3 class="text-xl font-semibold mb-4">{{ 'LEARNING_PATH_MANAGEMENT.TAGS' | translate }}</h3>
                  <mat-select [formControl]="etiquetteFilterCtrl"
                    class="w-full h-8 border border-gray-300 rounded-md px-3 py-1">
                    <mat-option>
                      <ngx-mat-select-search [formControl]="etiquetteFilterCtrl"
                        [placeholderLabel]="'LEARNING_PATH_MANAGEMENT.SEARCH' | translate"
                        [noEntriesFoundLabel]="'LEARNING_PATH_MANAGEMENT.NO_RESULTS' | translate">
                      </ngx-mat-select-search>
                    </mat-option>
                    @for (etiquette of filteredEtiquettesSearch | async; track etiquette) {
                      <mat-option
                        [value]="etiquette.etiquetteId">
                        {{etiquetteService.getNomLocalise(etiquette.locales)}}
                      </mat-option>
                    }
                  </mat-select>
                  <div class="mt-4 overflow-y-auto max-h-[300px]">
                    @for (etiquette of selectedEtiquettes; track etiquette) {
                      <div
                        class="flex items-center justify-between p-2 rounded mb-2 bg-white text-rougeNovo">
                        <div class="flex items-center gap-2">
                          <span>{{etiquetteService.getNomLocalise(etiquette.locales)}}</span>
                          <mat-icon (click)="showUtilisateursEtiquette(etiquette)"
                          class="material-icons-outlined text-black-500 hover:text-red-700 cursor-pointer inline-flex items-center justify-center h-5 w-5 align-middle selected-tag-icon">visibility</mat-icon>
                        </div>
                        <button mat-icon-button (click)="removeEtiquette(etiquette.etiquetteId)"
                          class="text-rougeNovo">
                          <mat-icon>close</mat-icon>
                        </button>
                      </div>
                    }
                  </div>
                </div>
                <div class="p-6 rounded-md border border-gray-300">
                  <h3 class="text-xl font-semibold mb-4">{{ 'LEARNING_PATH_MANAGEMENT.USERS' | translate }}</h3>
                  <mat-select [formControl]="utilisateurFilterCtrl"
                    class="w-full h-8 border border-gray-300 rounded-md px-3 py-1">
                    <mat-option>
                      <ngx-mat-select-search [formControl]="utilisateurFilterCtrl"
                        [placeholderLabel]="'LEARNING_PATH_MANAGEMENT.SEARCH' | translate"
                        [noEntriesFoundLabel]="'LEARNING_PATH_MANAGEMENT.NO_RESULTS' | translate">
                      </ngx-mat-select-search>
                    </mat-option>
                    @for (utilisateur of filteredUtilisateursSearch | async; track utilisateur) {
                      <mat-option
                        [value]="utilisateur.utilisateurId">
                        {{utilisateur.nom}}
                      </mat-option>
                    }
                  </mat-select>
                  <div class="mt-4 overflow-y-auto max-h-[300px]">
                    @for (utilisateur of selectedUtilisateurs; track utilisateur) {
                      <div
                        class="flex items-center justify-between p-2 rounded mb-2 bg-white text-rougeNovo">
                        <span>{{utilisateur.nom}}</span>
                        <button mat-icon-button (click)="removeUtilisateur(utilisateur.utilisateurId)"
                          class="text-rougeNovo">
                          <mat-icon>close</mat-icon>
                        </button>
                      </div>
                    }
                  </div>
                </div>
              </div>
            </div>
            <div class="flex justify-end gap-4 mt-8 p-4">
              <button (click)="cancel()" class="btn-secondary-novo">
                {{ 'LEARNING_PATH_MANAGEMENT.CANCEL' | translate }}
              </button>
              <button appPreventDoubleClick (throttledClick)="save()" [disabled]="!isValid() || isSaving" [ngClass]="{'opacity-50 cursor-not-allowed': !isValid() || isSaving}"
                class="btn-primary-novo">
                {{ 'LEARNING_PATH_MANAGEMENT.SAVE' | translate }}
              </button>
            </div>
          </div>
        }
      </div>